<template>
    <div>
        <MakeClassScheduleFeed style="flex:1; display:flex; flex-direction: column; overflow:hidden;" :mode="MAKE_SCHEDULE_MODE.POPUP" :completeAction="closeAction" :isOpen="true" :scheduleIdx="scheduleIdx" :is-copy="isCopy"/>
    </div>
</template>

<script>
import MakeClassScheduleFeed, { MAKE_SCHEDULE_MODE } from "@/components/modal/lesson/MakeClassScheduleFeed"
import { FORM_MODE } from "@/Constants";

export default {
    name: "MakeClassScheduleFeedPopup",
    components: { MakeClassScheduleFeed },
    props: {
        scheduleIdx: {
            type: [Number, String],
            default: ''
        },
        replyDeep: {
            type: Number,
            default: 1
        },
        joinIdx: {
            type: Number,
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => {}
        },
        isCopy : {
            type : Boolean,
            default : false
        }
    },
    data() {
        return {
            MAKE_SCHEDULE_MODE: MAKE_SCHEDULE_MODE,
            isOpen: false,
        }
    },
    methods: {
        closeAction(isModify, join_schedule_idx = null) {
            if (isModify) {
                this.completeAction(join_schedule_idx)
            }
            if(this.isOpen) {
                this.isOpen = false;
                return;
            }
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        ActBeforeClose(mode) {
            if (mode === FORM_MODE.DELETE) {
                this.closeAction();
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 0)
    },
    created() {
        //this.$GlobalStore.addModal('TestModal', {transitionName : '', isModalBackTransparent : true});
    }
}
</script>

<style scoped></style>